import { Button, Separator } from '@vake/ui-kit';
import { Link } from 'react-router-dom';

export const Menu = () => {
    return (
        <div className="flex flex-col gap-2 w-28">
            <Link to={'/user'}>
                <Button text="Go to Home" variant="subtle" size="small" />
            </Link>
            <Separator opaque />
            <Link to={'/overwatch-reports'}>
                <Button text="Go to Reports" variant="subtle" size="small" />
            </Link>
        </div>
    );
};
